import { ChannelAdminsState } from './types';

export const initialState: ChannelAdminsState = {
  admins: [],
  temporarilyLockedEmails: {},
  workingPermissions: null,
  unlockingEmail: false,
  activeChannelProducersAndPresenters: null,
};
